import {
  DITypes,
  F360Product,
  FinancasUserRoles,
  IF360Sidebar
} from "@/core/@types/types";
import LogoIconPurple from "@/ui/assets/f360-icon-purple.png";
import LogoIconYellow from "@/ui/assets/f360-icon-yellow.png";
import useCentralDeAjudaCielo from "@/ui/components/Layout/Sidebar/useCentralDeAjudaCielo";
import { diContainer } from "@/core/di";
import { type IFinancasGateway } from "@/core/services/financas/gateways/FinancasGateway";
import { inject, injectable } from "inversify";
import F360Sidebar from "./F360AbstractSidebar";
import F360ContabilSidebarConfig from "../../features/contabil/common/sidebar/F360ContabilSidebarConfig";
import F360FinancasSidebarConfig from "./financas/sidebar/F360FinancasSidebarConfig";
import WhatsAppIcon from "@/ui/assets/whatsapp.svg";

import "reflect-metadata";
import { EFinancasRoutes } from "../router/financas/credenciamento/types";
import { getRouterConfigDashBobs } from "@/features/financas/views/Indicadores/widgets/Banners/DashBobs/router/RouterDashBobs";
import { EStoreRoutes } from "@/features/store/enums/StoreRouterEnums";

@injectable()
export default class extends F360Sidebar {
  @inject(DITypes.FINANCAS_AUTH)
  private client!: IFinancasGateway;

  private getLogEduca = async () => {
    const url = await this.client.getUrlLoginEduca();

    if (!url) {
      throw new Error(
        "Ocorreu um erro ao tentar obter a sua URL de login do F360 Educa! Se o problema persistir, entre em contato com o suporte do sistema."
      );
    }

    window.open(url, "_blank", "noopener");
  };

  private handleContabilSidebar() {
    return diContainer.get(F360ContabilSidebarConfig).handleSidebar();
  }

  private handleFinancasSidebar() {
    return diContainer.get(F360FinancasSidebarConfig).handleSidebar();
  }

  private handleConfiguracoesSidebar() {
    return diContainer.get(F360FinancasSidebarConfig).handleMenuConfiguracoes();
  }

  handleSidebar = (): Array<IF360Sidebar> => [
    ...this.handleConfiguracoesSidebar(),
    {
      menuLabel: "Antecipa",
      //customClass: "novidade-pulse-icon",
      showBagde: true,
      img: LogoIconYellow,
      routerConfig: {
        routeName: EFinancasRoutes.antecipa,
        product: F360Product.Antecipa
      },
      validator: [
        !this.isCielo(),
        this.hasAntecipaFeatureFlag(),
        this.isUsuarioAdmin()
      ]
    },
    ...this.handleFinancasSidebar(),
    getRouterConfigDashBobs(),
    ...this.handleContabilSidebar(),
    {
      menuLabel: "Educa",
      img: LogoIconPurple,
      routerConfig: async () => await this.getLogEduca(),
      validator: [this.showEduca(), !this.isSysAdmin()]
    },
    {
      menuLabel: "Store",
      icon: "storefront",
      iconClass: "f360-menu-icon--store",
      routerConfig: {
        product: F360Product.FinancasNewHorizons,
        routeName: EStoreRoutes.Index,
        hasSubRoutes: false
      },
      validator: [!this.isCielo(), this.isUsuarioAdmin(), !this.isSysAdmin()],
      roles: [FinancasUserRoles.Store]
    },
    {
      menuLabel: "Ajuda",
      validator: [this.isCielo()],
      isInfo: true
    },
    {
      menuLabel: "Treinamentos",
      routerConfig: {
        product: F360Product.FinancasNewHorizons,
        routeName: EFinancasRoutes.treinamentos
      },
      icon: "smart_display",
      validator: [this.isCielo(), !this.isSysAdmin()],
      isItem: true
    },
    {
      menuLabel: "Fale conosco",
      routerConfig: async () => {
        const { handleOpenCentral } = useCentralDeAjudaCielo();

        handleOpenCentral({ name: "Fale conosco" });
      },
      icon: "forum",
      validator: [this.isCielo(), !this.isSysAdmin()],
      isItem: true
    },
    {
      menuLabel: "Ajuda por WhatsApp",
      routerConfig: async () => {
        const phoneNumber = "5511934484320"; // número cielo conciliador
        const whatsappUrl = `https://wa.me/${phoneNumber}`;

        window.open(whatsappUrl, "_blank", "noopener");
      },
      img: WhatsAppIcon,
      icon: "whatsapp",
      validator: [this.isCielo(), !this.isSysAdmin()],
      isItem: true
    }
  ];
}
